export const TokenPermissionModule = {
  SUPPLIERS: "suppliers",
  SUPPLIER_PROFILE_ALL: "supplier-profile-all",
  SUPPLIER_PROFILE_MANAGED: "supplier-profile-managed",
  // Raw flow - using backend token format from OEP
  RAW: "raw",
  // Raw dashboard - required by /v2/experience-raw-content endpoint (shared by
  // Raw Commercial, Operational and 3rd Party Raw dashboards)
  RAW_DASHBOARD: "raw-dashboard",
  // Internal raw (Opinoia) flow
  INTERNAL_RAW: "internal-raw",
  // Media flow
  MEDIA: "media",
  // Curation (Editorial) content - backend uses "editorial-content" (edit/publish the content)
  EDITORIAL_CONTENT: "editorial-content",
  // Curation dashboard - gates the Curation listing, mirroring RAW_DASHBOARD for raw
  EDITORIAL_DASHBOARD: "editorial-dashboard",
  // Translation flow - backend uses "translations" (plural)
  TRANSLATIONS: "translations",
  // Calendar/Options flow
  CALENDAR: "calendar",
  // Masterdata flow
  MASTERDATA: "masterdata",
} as const;

export type TokenPermissionModuleType = (typeof TokenPermissionModule)[keyof typeof TokenPermissionModule];

export const TokenPermissionAction = {
  VIEW: "VIEW",
  EDIT: "EDIT",
} as const;

export type TokenPermissionActionType = (typeof TokenPermissionAction)[keyof typeof TokenPermissionAction];

function getTokenPermission(module: TokenPermissionModuleType, action: TokenPermissionActionType): string {
  return `${module}-${action}`;
}

export function getTokenViewPermission(module: TokenPermissionModuleType): string {
  return getTokenPermission(module, TokenPermissionAction.VIEW);
}

export function getTokenEditPermission(module: TokenPermissionModuleType): string {
  return getTokenPermission(module, TokenPermissionAction.EDIT);
}

export function getTokenPermissionsForModule(module: TokenPermissionModuleType): string[] {
  return [getTokenViewPermission(module), getTokenEditPermission(module)];
}
